import chroma, { contrast, scale } from 'chroma-js';
import { isString } from 'lodash';

export const LIGHTNESS_FACTOR = 0.7;

interface IColorBrewer {
  [brewerKey: string]: { [colorCount: number]: string[] };
}
/*
 * Begin Color Brewer object
 * This product includes color specifications and designs developed by Cynthia Brewer (http://colorbrewer.org/).
 * JavaScript specs as packaged in the D3 library (d3js.org). Please see license at http://colorbrewer.org/export/LICENSE.txt
 * Colors from https://dev.blackrock.com/apps/apgux/#/docs/foundations/data-visualization
 * The format of this expect there to be arrays for values from 1 to 7 inclusive.
 */
export const ColorBrewer: IColorBrewer = {
  /*
   * Greys not from data-visualization page but left here as there are not defined colors on that page for
   * light and dark grey and it seems like those may be useful.
   * Value for 1 given as an array of two values as if you only put in one value
   * chroma errors out.
   */
  LightGreys: {
    1: ['#969696', '#969696'],
    2: ['#969696', '#969696'],
    3: ['#969696', '#969696'],
    4: ['#969696', '#969696'],
    5: ['#969696', '#969696'],
    6: ['#969696', '#969696'],
    7: ['#969696', '#969696'],
  },
  DarkGreys: {
    1: ['#525252', '#525252'],
    2: ['#525252', '#525252'],
    3: ['#525252', '#525252'],
    4: ['#525252', '#525252'],
    5: ['#525252', '#525252'],
    6: ['#525252', '#525252'],
    7: ['#525252', '#525252'],
  },
  Blues: {
    1: ['#0998f6', '#0998f6'],
    2: ['#69C0FA', '#0998f6'],
    3: ['#9BD5FC', '#69C0FA', '#0998f6'],
    4: ['#CDEAFE', '#9BD5FC', '#69C0FA', '#0998f6'],
    5: ['#CDEAFE', '#9BD5FC', '#69C0FA', '#0998f6', '#007AC9'],
    6: ['#CDEAFE', '#9BD5FC', '#69C0FA', '#0998f6', '#007AC9', '#005E9B'],
    7: ['#CDEAFE', '#9BD5FC', '#69C0FA', '#0998f6', '#007AC9', '#005E9B', '#003E65'],
  },
  GreenBlues: {
    1: ['#26D9BA', '#26D9BA'],
    2: ['#6EF7E0', '#26D9BA'],
    3: ['#A1F8E9', '#6EF7E0', '#26D9BA'],
    4: ['#CFFBF4', '#A1F8E9', '#6EF7E0', '#26D9BA'],
    5: ['#CFFBF4', '#A1F8E9', '#6EF7E0', '#26D9BA', '#1FAE96'],
    6: ['#CFFBF4', '#A1F8E9', '#6EF7E0', '#26D9BA', '#1FAE96', '#018670'],
    7: ['#CFFBF4', '#A1F8E9', '#6EF7E0', '#26D9BA', '#1FAE96', '#018670', '#086759'],
  },
  Oranges: {
    1: ['#FF8900', '#FD4F03'],
    2: ['#FFB764', '#FF8900'],
    3: ['#FFCF98', '#FFB764', '#FF8900'],
    4: ['#FFE8CE', '#FFCF98', '#FFB764', '#FF8900'],
    5: ['#FFE8CE', '#FFCF98', '#FFB764', '#FF8900', '#DC8118'],
    6: ['#FFE8CE', '#FFCF98', '#FFB764', '#FF8900', '#DC8118', '#AB6411'],
    7: ['#FFE8CE', '#FFCF98', '#FFB764', '#FF8900', '#DC8118', '#AB6411', '#814F15'],
  },

  OrangeReds: {
    1: ['#FD4F03', '#FD4F03'],
    2: ['#FF9364', '#FD4F03'],
    3: ['#FFB798', '#FF9364', '#FD4F03'],
    4: ['#FFDBCC', '#FFB798', '#FF9364', '#FD4F03'],
    5: ['#FFDBCC', '#FFB798', '#FF9364', '#FD4F03', '#DC4E10'],
    6: ['#FFDBCC', '#FFB798', '#FF9364', '#FD4F03', '#DC4E10', '#AC4011'],
    7: ['#FFDBCC', '#FFB798', '#FF9364', '#FD4F03', '#DC4E10', '#AC4011', '#782B0A'],
  },
  OrangeYellows: {
    1: ['#FFBF0B', '#FFBF0B'],
    2: ['#FFDB75', '#FFBF0B'],
    3: ['#FFF8A7', '#FFDB75', '#FFBF0B'],
    4: ['#FFF6DB', '#FFF8A7', '#FFDB75', '#FFBF0B'],
    5: ['#FFF6DB', '#FFF8A7', '#FFDB75', '#FFBF0B', '#d7A720'],
    6: ['#FFF6DB', '#FFF8A7', '#FFDB75', '#FFBF0B', '#d7A720', '#AF8C29'],
    7: ['#FFF6DB', '#FFF8A7', '#FFDB75', '#FFBF0B', '#d7A720', '#AF8C29', '#71602E'],
  },
  Purples: {
    1: ['#9952E0', '#9952E0'],
    2: ['#EF6CE5', '#9952E0'],
    3: ['#E4CCFC', '#EF6CE5', '#9952E0'],
    4: ['#EFE0FE', '#E4CCFC', '#EF6CE5', '#9952E0'],
    5: ['#EFE0FE', '#E4CCFC', '#EF6CE5', '#9952E0', '#7E28D8'],
    6: ['#EFE0FE', '#E4CCFC', '#EF6CE5', '#9952E0', '#7E28D8', '#651EB0'],
    7: ['#EFE0FE', '#E4CCFC', '#EF6CE5', '#9952E0', '#7E28D8', '#651EB0', '#4B009A'],
  },
  PurpleReds: {
    1: ['#CB2CC0', '#CB2CC0'],
    2: ['#EF6CE5', '#CB2CC0'],
    3: ['#F49BED', '#EF6CE5', '#CB2CC0'],
    4: ['#F9C6F5', '#F49BED', '#EF6CE5', '#CB2CC0'],
    5: ['#F9C6F5', '#F49BED', '#EF6CE5', '#CB2CC0', '#A02398'],
    6: ['#F9C6F5', '#F49BED', '#EF6CE5', '#CB2CC0', '#A02398', '#721276'],
    7: ['#F9C6F5', '#F49BED', '#EF6CE5', '#CB2CC0', '#A02398', '#721276', '#5B0055'],
  },
  VeryLightGreys: {
    1: ['#F1F2F4', '#DADDE1'],
    2: ['#F1F2F4', '#DADDE1'],
    3: ['#F1F2F4', '#DADDE1', '#C0C4C9'],
    4: ['#F1F2F4', '#DADDE1', '#C0C4C9'],
    5: ['#F1F2F4', '#DADDE1', '#C0C4C9'],
    6: ['#F1F2F4', '#DADDE1', '#C0C4C9'],
    7: ['#F1F2F4', '#DADDE1', '#C0C4C9'],
  },
};

export enum DEFAULT_COLORS {
  DARK_BLUE = '#007AC9',
  LIGHT_BLUE = '#9BD5FC',
}

/**
 * Qualitative (categorical) colors listed in consecutive order as defined in the Design System.
 */
export const COLOR_LIST = [
  '#007AC9',
  '#CB2CC0',
  '#1FAE96',
  '#FF7132',
  '#9952E0',
  '#D7A720',
  '#1D1DB1',
  '#048119',
  '#4C64F8',
  '#BC0300',
  '#003E65',
  '#0998F6',
  '#26D9BA',
  '#A02398',
  '#FD4F03',
  '#7E28D8',
];

// Colors specified by design team (Alex) for use in user selected colors
export const ICON_COLORS = ['#EF6CE5', '#3AEF59', '#FF2825', '#FF8900'];

export interface PaletteMap {
  [key: string]: string | PaletteMap;
}

export const paletteMap: PaletteMap = {
  Equity: 'Blues',
  'Fixed Income': 'PurpleReds',
  Allocation: 'GreenBlues',
  Alternative: 'Oranges',
  Other: 'OrangeReds',
  Cash: 'OrangeYellows',
  'Foreign Exchange': 'Purples',
};

export const getColorFromList = (index: number) => COLOR_LIST[Math.floor(Math.abs(index)) % COLOR_LIST.length];

// Takes a palette string and creates an array of lightening colors by size.
export const lightenColors = (palette: string, size: number = 0, lightness: number = 0.5) => {
  const lighterPalette = scale([palette, '#FFF'])(lightness);
  // Creates an array of colors from palette color to 50% lightened palette color.
  return scale([palette, lighterPalette]).colors(size);
};

export const getColorArrayAndLength = (
  palette: string,
  size: number = 0
): { colorArray: string[]; colorLength: number } => {
  if (size > 7) {
    size = 7;
  }
  let colorArray: string[] = [];
  if (ColorBrewer.hasOwnProperty(palette)) {
    /*
     * Putting in the || catch so that if for some reason we are not able to find the value in production
     * we show just it with only one color as opposed to crashing the page.
     */
    colorArray = ColorBrewer[palette][size] || Object.values(ColorBrewer[palette])[0];
  } else {
    // This allows for palleteMap to also just return a specific color.
    colorArray = [palette, palette];
  }
  return { colorArray, colorLength: size };
};

export const getPaletteColorsOnly = (palette: string, size: number = 0): string[] => {
  if (isString(palette)) {
    const { colorArray, colorLength } = getColorArrayAndLength(palette, size);
    const timesExceeded = colorLength !== 0 ? Math.floor(size / colorLength) : 0;
    const scaleObj = scale(colorArray);
    return scaleObj.colors(timesExceeded > 1 ? colorLength * timesExceeded : colorLength);
  }
  return palette;
};

// Given a breakdown name or order number, choose the best set of colors to represent it
export const getBreakdownColors = (breakdownNameOrOrder?: string | number, size: number = 1) => {
  if (typeof breakdownNameOrOrder === 'undefined') {
    return [''];
  }
  if (typeof breakdownNameOrOrder === 'number') {
    if (breakdownNameOrOrder < COLOR_LIST.length) {
      return lightenColors(COLOR_LIST[breakdownNameOrOrder], size);
    }
    // if we run out of colors, loop from the beginning
    return lightenColors(COLOR_LIST[breakdownNameOrOrder % COLOR_LIST.length], size);
  }
  if (ColorBrewer.hasOwnProperty(breakdownNameOrOrder)) {
    return getPaletteColorsOnly(breakdownNameOrOrder, size);
  }
  if (typeof breakdownNameOrOrder === 'string' && size === 1) {
    // this must be a string hex code given by the config so return as is
    return [breakdownNameOrOrder];
  }
  return lightenColors(breakdownNameOrOrder, size);
};

/**
 * polyfill of https://github.com/gka/chroma.js/blob/main/src/utils/valid.js
 * since it's available only from v2.0.1 https://www.vis4.net/chromajs/#2-0-1
 * @param color
 */
export const isValidColor = (color: string) => {
  try {
    chroma(color);
    return true;
  } catch (e) {
    console.warn('Invalid color ' + color);
    return false;
  }
};

/**
 * Determines the most accessible text color (black or white) for a given background color
 * by comparing contrast ratios.
 *
 * @param color - The background color as a hex string, RGB, or any valid color format
 * @returns Either '#000' (black) or '#FFF' (white) - whichever provides better contrast
 *
 * @example
 * ```typescript
 * getAccessibleColor('#FF0000') // Returns '#FFF' (white text on red background)
 * getAccessibleColor('#FFFF00') // Returns '#000' (black text on yellow background)
 * ```
 */
export const getAccessibleColor = (color: string) => {
  const dark = '#000';
  const light = '#FFF';
  return contrast(color, dark) >= contrast(color, light) ? dark : light;
};

/**
 * Picks the highest contrast label color for data visualization elements.
 * Returns the most accessible text color for the given background color,
 * or defaults to black if no color is provided.
 *
 * @param color - Optional background color as a hex string, RGB, or any valid color format
 * @returns The most accessible text color ('#000' or '#FFF'), defaults to '#000' if no color provided
 *
 * @example
 * ```typescript
 * getDataLabelColor('#0066CC') // Returns '#FFF' for better contrast
 * getDataLabelColor() // Returns '#000' (default)
 * getDataLabelColor('#F5F5F5') // Returns '#000' for better contrast
 * ```
 */
export const getDataLabelColor = (color?: string) => (color ? getAccessibleColor(color) : '#000');

/**
 * Returns an accessible font color (black or white) for a given background and font color, following WCAG contrast standards.
 * If the provided font color does meet the minimum contrast ratio (4.5:1) against the background, returns the font color else the most accessible alternative ('#000' or '#FFF').
 * If fontColor is nor provided returns the most accessible alternative ('#000' or '#FFF') against the background color.
 * If the background color is invalid it returns the font color as is.
 *
 * @param bgColor - Background color (hex, RGB, or any chroma.js-supported format)
 * @param fontColor - Optional font color to test for accessibility. If omitted or invalid, uses bgColor for contrast check.
 * @returns Accessible font color ('#000', '#FFF', or fontColor if fallback)
 *
 * @example
 * // Returns '#FFF' (white) for better contrast
 * getAccessibleFontColor('#FF0000', '#FF8888')
 * // Returns '#FFFFFF' (passes contrast test)
 * getAccessibleFontColor('#000000', '#FFFFFF')
 * // Returns '#FFFFFF' (no font color provided)
 * getAccessibleFontColor('#000000')
 * // Returns '#000' (BG color invalid)
 * getAccessibleFontColor('transparent', "#000")
 * // Returns undefined (since BG color invalid & no font color provided)
 * getAccessibleFontColor('transparent')
 */
export const getAccessibleFontColor = (bgColor: string, fontColor?: string) => {
  const isValidFontColor = fontColor && isValidColor(fontColor);
  const isValidBgColor = isValidColor(bgColor);

  if (isValidBgColor && isValidFontColor) {
    return contrast(bgColor, fontColor) < 4.5 ? getAccessibleColor(bgColor) : fontColor;
  }

  if (isValidBgColor) {
    return getAccessibleColor(bgColor);
  }

  return fontColor;
};
